export const BOARD_THUMBNAIL_DEFAULT_URL =
  'https://ik.imagekit.io/landing/webAssets/board-thumbnail-default_kSgUyckik.png';
